module.exports = __webpack_public_path__ + "img/csr_swiper_09.c069643d.jpg";